import Flag from './icon/Flag'

export {
    Flag
};